/* eslint-disable jsx-a11y/alt-text */
import { Dialog, makeStyles } from '@material-ui/core';
import Image from 'next/image';
import React, { useCallback, useEffect, useState } from 'react';
import { delayTimer } from '../../../utility/cr-common';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: '884px',
    minHeight: 'calc(100vh - 64px);',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  innerContainer: {
    marginTop: '5%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    textAlign: 'justify',
  },
  textContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    color: '#062b68',
    fontFamily: 'IBM Plex Sans',
  },
  heading: {
    fontSize: '49px',
    lineHeight: '1',
    width: '460px',
  },
  subHeading: {
    fontSize: '40px',
    textAlign: 'center',
    width: '451px',
  },
  paragraph: {
    fontSize: '16px',
    width: '451px',
  },
  image: {
    padding: 8,
  },
}));

const UnderMaintenance = () => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);

  const loadPage = useCallback(async () => {
    await delayTimer(3000);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    loadPage();
  }, [loadPage]);

  return (
    <div className={classes.root}>
      <div className={classes.innerContainer}>
        <div className={classes.textContainer}>
          <h1 className={`${classes.heading} m-0`}>Quattr Maintenance</h1>
          <h1 className={`${classes.subHeading} m-0`}>Work In Progress</h1>
          <br />
          <h1 className={`${classes.paragraph} m-0`}>
            The page you are trying to reach is currently under maintenance. We apologize for the inconvenience. Hang
            tight—we’ll notify you via email as soon as we’re back up. Thank you for your patience and understanding.
          </h1>
          {/* <h1 className='m-0' style={{ fontSize: "24px" }}>Please check back soon.</h1> */}
        </div>
        <Image className={classes.image} src={'/Maintenance.png'} height="432" width="432" layout="fixed" />
      </div>
    </div>
  );
};

export default React.memo(UnderMaintenance);
